import type { CustomNode, CustomEdge } from '@src/components/custom-nodes/types';
import { atom, createStore } from 'jotai';

interface EditorPayload {
  nodes: CustomNode[];
  edges: CustomEdge[];
}
export const dndNodeItemAtom = atom<EditorPayload | null>(null);

export const dndNodeStore = createStore();

export const setDndNodeItem = (item: EditorPayload) => dndNodeStore.set(dndNodeItemAtom, item);
export const getDndNodeItem = () => dndNodeStore.get(dndNodeItemAtom);
export const clearDndNodeItem = () => dndNodeStore.set(dndNodeItemAtom, null);
